import { Axios } from "@/utils/axios";

interface LeadConsentRecord {
  phone: string;
  agreement: {
    marketing_agreed: boolean;
  };
}

export const postLeadConsentRecord = async (body: LeadConsentRecord) => {
  const { data } = await Axios.post("/lead_consent_records/", body);
  return data;
};
